import { useState } from 'react';
import { useSelector } from 'react-redux';
var Forms = function Forms(_ref) {
  var _popup$files;
  var popupID = _ref.popupID;
  var popup = useSelector(function (s) {
    return s.popups[popupID] || {};
  });
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "article__content forms__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a__title popup__title"
  }, /*#__PURE__*/React.createElement("h1", null, popup === null || popup === void 0 ? void 0 : popup.title)), (popup === null || popup === void 0 ? void 0 : popup.subtitle) && /*#__PURE__*/React.createElement("div", {
    className: "a__subtitle forms__site"
  }, /*#__PURE__*/React.createElement("h4", null, popup === null || popup === void 0 ? void 0 : popup.subtitle)), popup === null || popup === void 0 ? void 0 : (_popup$files = popup.files) === null || _popup$files === void 0 ? void 0 : _popup$files.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "popup__row",
      key: 'form_' + x._id
    }, /*#__PURE__*/React.createElement("img", {
      src: "/public/images/pdf-icon.png"
    }), /*#__PURE__*/React.createElement("div", {
      className: "popup__row--title",
      onClick: function onClick() {
        var _x$assetID;
        window.open(bucket + '/' + ((_x$assetID = x.assetID) === null || _x$assetID === void 0 ? void 0 : _x$assetID.filename), '_blank');
      }
    }, x.title));
  }));
};
export default Forms;